import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import './ProfileHeader.css';
import logo from '../images/dc_logo.png';
import dp from '../images/profile_icon.png';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

const ProfileHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const headerStyle = {
        gap: `${Math.min(150, scrollY)}px`,
        marginTop: `${Math.min(15, scrollY / 5)}px`,
        opacity: `${1 - Math.min(scrollY / 300, 0.2)}`,
        width: `${100 - Math.min(scrollY / 5, 20)}%`, // Starts at 100% and transitions to 80%
        borderRadius: `${Math.min(15, scrollY / 10)}px`, // Starts at 0px and transitions to 15px
    };

    return (
        <header className="pheader">
            <div className="logo-area">
                <img className="logo-image" src={logo} alt="logo" />
                <div className="logo" onClick={() => {navigate('/')}}>The Ideal Pursuits</div>
            </div>
            <nav className={`nav ${menuOpen ? 'active' : ''}`}>
                <motion.a whileHover={{ scale: 1.1 }} className="nav-link" onClick={logout}>
                    <button className="join-button" onClick={()=>navigate('/', { replace: true })}>
                        Log out
                    </button>
                </motion.a>
            </nav>
        </header>
    );
};

export default ProfileHeader;
